// Analytics and logging utility for application usage tracking
import { logUsage } from '../firebase';

/**
 * Log a page view
 */
export const logPageView = (pageName, additionalData = {}) => {
  const logData = {
    type: 'page_view',
    page: pageName,
    // Don't send timestamp - backend will use serverTimestamp()
    ...additionalData
  };
  
  logUsage(logData).catch(error => {
    console.error('Failed to log page view:', error);
  });
};

/**
 * Log a user action
 */
export const logUserAction = (action, details = {}) => {
  const logData = {
    type: 'user_action',
    action: action,
    // Don't send timestamp - backend will use serverTimestamp()
    ...details
  };
  
  logUsage(logData).catch(error => {
    console.error('Failed to log user action:', error);
  });
};

/**
 * Log a function call
 */
export const logFunctionCall = (functionName, success, duration, error = null) => {
  const logData = {
    type: 'function_call',
    function: functionName,
    success: success,
    duration: duration,
    // Don't send timestamp - backend will use serverTimestamp()
    ...(error && { error: error.message || String(error) })
  };
  
  logUsage(logData).catch(err => {
    console.error('Failed to log function call:', err);
  });
};

/**
 * Log an error
 */
export const logError = (error, context = {}) => {
  const logData = {
    type: 'error',
    error: error.message || String(error),
    stack: error.stack,
    // Don't send timestamp - backend will use serverTimestamp()
    ...context
  };
  
  logUsage(logData).catch(err => {
    console.error('Failed to log error:', err);
  });
};

/**
 * Log performance metrics
 */
export const logPerformance = (metric, value, unit = 'ms') => {
  const logData = {
    type: 'performance',
    metric: metric,
    value: value,
    unit: unit
    // Don't send timestamp - backend will use serverTimestamp()
  };
  
  logUsage(logData).catch(error => {
    console.error('Failed to log performance:', error);
  });
};

